import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { ButtonModule } from 'primeng/button';
import { Card } from 'primeng/card';

import { AuthService } from '@shared/auth';
import { ENVIRONMENT_CONFIG, EnvironmentConfig } from '@shared/config';

@Component({
  selector: 'pulse-user-data-error',
  templateUrl: './user-data-error.component.html',
  styleUrl: './user-data-error.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonModule, Card]
})
export class UserDataErrorComponent {
  private authService = inject(AuthService);
  private config = inject<EnvironmentConfig>(ENVIRONMENT_CONFIG);

  readonly supportEmail = this.config.supportEmailAddress;
  readonly supportEmailHref = `mailto:${this.supportEmail}`;

  onLoginClick(): void {
    // Show the account picker so a session from another Pulse app is not reused.
    this.authService.login({ prompt: 'login' });
  }
}
